/**
 * Template ID fragments for Confluence status update templates.
 *
 */
const STATUS_UPDATE_TEMPLATE_KEY_FRAGMENTS: readonly string[] = [
	'eow-status-report', // End of week status report
];

/** Returns true when the template ID matches a Confluence status update template. */
export const matchesStatusUpdateTemplate = (templateId: string | null | undefined): boolean => {
	if (!templateId) {
		return false;
	}
	const normalised = templateId.toLowerCase();
	return STATUS_UPDATE_TEMPLATE_KEY_FRAGMENTS.some((fragment) => normalised.includes(fragment));
};
